export const fieldTypes = {
	CHECKBOX: "CHECKBOX",
	PERMANENT_TEXT: "PERMANENT_TEXT",
	TEXT: "TEXT",
	TEXTAREA: "TEXTAREA",
	NUMBER: "NUMBER",
	DATE: "DATE",
	LIST_ONE_CHOICE: "LIST_ONE_CHOICE",
	CHECKBOX_LIST_ONE_CHOICE: "CHECKBOX_LIST_ONE_CHOICE",
	RADIO_LIST_ONE_CHOICE: "RADIO_LIST_ONE_CHOICE",
	LIST_MULTI_CHOICE: "LIST_MULTI_CHOICE",
	RADIO_LIST_MULTI_CHOICE: "RADIO_LIST_MULTI_CHOICE",
	CHECKBOX_LIST_MULTI_CHOICE: "CHECKBOX_LIST_MULTI_CHOICE",
	ATTACHMENT: "ATTACHMENT",
	CONDITIONAL: "CONDITIONAL",
	TABLE: "TABLE",

	getPolishNameByBusinessName(name) {
		switch (name) {
			case this.CHECKBOX:
				return polishNames.POLISH_CHECKBOX;

			case this.PERMANENT_TEXT:
				return polishNames.POLISH_PERMANENT_TEXT;

			case this.TEXT:
				return polishNames.POLISH_TEXT;

			case this.TEXTAREA:
				return polishNames.POLISH_TEXTAREA;
			case this.NUMBER:
				return polishNames.POLISH_NUMBER;

			case this.DATE:
				return polishNames.POLISH_DATE;

			case this.LIST_ONE_CHOICE:
				return polishNames.POLISH_LIST_ONE_CHOICE;

			case this.RADIO_LIST_ONE_CHOICE:
				return polishNames.POLISH_RADIO_LIST_ONE_CHOICE;

			case this.RADIO_LIST_MULTI_CHOICE:
				return polishNames.POLISH_RADIO_LIST_MULTI_CHOICE;

			case this.CHECKBOX_LIST_MULTI_CHOICE:
				return polishNames.POLISH_CHECKBOX_LIST_MULTI_CHOICE;

			case this.ATTACHMENT:
				return polishNames.POLISH_ATTACHMENT;

			case this.CONDITIONAL:
				return polishNames.POLISH_CONDITIONAL;

			case this.TABLE:
				return polishNames.POLISH_TABLE;
		}
	},

	getBusinessNameByPolishName(name) {
		switch (name) {
			case polishNames.POLISH_CHECKBOX:
				return this.CHECKBOX;

			case polishNames.POLISH_PERMANENT_TEXT:
				return this.PERMANENT_TEXT;

			case polishNames.POLISH_TEXT:
				return this.TEXT;

			case polishNames.POLISH_TEXTAREA:
				return this.TEXTAREA;

			case polishNames.POLISH_NUMBER:
				return this.NUMBER;

			case polishNames.POLISH_DATE:
				return this.DATE;

			case polishNames.POLISH_LIST_ONE_CHOICE:
				return this.LIST_ONE_CHOICE;

			case polishNames.POLISH_RADIO_LIST_ONE_CHOICE:
				return this.RADIO_LIST_ONE_CHOICE;

			case polishNames.POLISH_RADIO_LIST_MULTI_CHOICE:
				return this.RADIO_LIST_MULTI_CHOICE;

			case polishNames.POLISH_CHECKBOX_LIST_MULTI_CHOICE:
				return this.CHECKBOX_LIST_MULTI_CHOICE;

			case polishNames.POLISH_ATTACHMENT:
				return this.ATTACHMENT;

			case polishNames.POLISH_CONDITIONAL:
				return this.CONDITIONAL;

			case polishNames.POLISH_TABLE:
				return this.TABLE;
		}
	},

	getAllPolishNames() {
		return Object.keys(polishNames).map(function (key) {
			return polishNames[key];
		});
	},
};

const polishNames = {
	// kolejność pol w tym obiekcie odpowiada kolejnosci wyswietlania ich w panelu do tworzenia formularza generycznego
	POLISH_PERMANENT_TEXT: "Stały tekst",
	POLISH_TEXT: "Pole tekstowe - małe",
	POLISH_TEXTAREA: "Pole tekstowe - duże",
	POLISH_NUMBER: "Pole liczbowe",
	POLISH_DATE: "Pole daty",
	POLISH_TABLE: "Tabela",
	POLISH_LIST_ONE_CHOICE: "Pole wyboru jednokrotnego - lista rozwijana",
	POLISH_RADIO_LIST_ONE_CHOICE: "Pole wyboru jednokrotnego - lista radio",
	POLISH_CHECKBOX_LIST_MULTI_CHOICE: "Pole wyboru wielokrotnego - lista rozwijana",
	POLISH_RADIO_LIST_MULTI_CHOICE: "Pole wyboru wielokrotnego - lista radio",
	POLISH_CHECKBOX: "Checkbox",
	POLISH_CONDITIONAL: "Pole warunkujące - slider",
	POLISH_ATTACHMENT: "Pole dodania załącznika",
};
